module.exports = __webpack_public_path__ + "media/images/expert__arnd-peiffer-9cef3c8d7144e9b7370cd6383fc25fa3.png";